/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublisherListModel } from '../../models/publisher-list-model';

export interface PublisherPublisherListGet$Json$Params {
}

export function publisherPublisherListGet$Json(http: HttpClient, rootUrl: string, params?: PublisherPublisherListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<PublisherListModel>>> {
  const rb = new RequestBuilder(rootUrl, publisherPublisherListGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<PublisherListModel>>;
    })
  );
}

publisherPublisherListGet$Json.PATH = '/Publisher/PublisherList';
